import { urlContexts } from "../../constants";
import { getUserInfo } from "./getUserInfo";
import { getInactivityParams } from "./getInactivityParams";
import { getRefreshToken } from "./getRefreshToken";
import { logout } from "./logout";
import { jwtDecode } from "jwt-decode";
import { selectApplication, selectRole, selectTenant } from "./selectActions";

const token = sessionStorage.getItem('REDIRECT::INFO') || new URLSearchParams(window.location.search).get('token') || '';
const sessionTimeOut = +(sessionStorage.getItem('SESSION::TIMEOUT') || new URLSearchParams(window.location.search).get('sessiontimeout') || '60');
!sessionStorage?.getItem('SESSION::TIMEOUT') && sessionStorage.setItem('SESSION::TIMEOUT', sessionTimeOut.toString());
sessionStorage.setItem('REDIRECT::INFO', token);
const expDate = new Date();
expDate.setMinutes(expDate.getMinutes() + 5);
const tokenPayload = token
    ? jwtDecode(token)
    : {
        exp: expDate.getTime() / 1000,
        iat: new Date().getTime() / 1000,
        sessionid: '',
    };

const initIam = async (onAuthenticatedCallback: (info: {
    username: string
    lastname: string,
    expires_in: number;
    timeToExpire: number;
    tenantId: string;
    tokenExpireTime: number;
    sessionTimeOut: number;
    userId: string;
}) => void) => {
    getUserInfo()
        .then(async response => {
            if (response?.header?.errorCode === '200') {
                await refreshToken();
                const timesToInactivity = await inactivityParams();
                const expires_in = timesToInactivity?.show_alert_inactivity_after || 300;
                const timeToExpire = (timesToInactivity?.automatic_close_session_after ?? 420) - expires_in;
                const tokenExpireTime = parseInt(sessionStorage?.getItem('TOKEN::EXPIREINFO') ?? '60', 10) - 30;
                sessionStorage.removeItem('TOKEN::EXPIREINFO');
                let info = {
                    username: response?.data?.firstName,
                    lastname: response?.data?.lastName,
                    userId: response?.data?.id,
                    expires_in: expires_in,
                    timeToExpire: timeToExpire,
                    tenantId: response?.data?.tenantId,
                    tokenExpireTime: tokenExpireTime,
                    sessionTimeOut: sessionTimeOut,
                }
                onAuthenticatedCallback(info);
            }
            else {
                sessionStorage.removeItem('REDIRECT::INFO');
                sessionStorage.removeItem('CONSOLE::MENU');
                window.location.href = (
                    (process.env['REACT_APP_IAM_FRONT_HOST']
                        ? process.env['REACT_APP_IAM_FRONT_HOST']
                        : process.env['REACT_APP_BACKEND_HOST'])
                    || 'http://localhost:3001') + '/' + urlContexts.iam_front;
            }
        })
        .catch((error) => {
            console.log(error)
            // if (error.error === 'access_denied') doLogout()
            sessionStorage.removeItem('REDIRECT::INFO');
            sessionStorage.removeItem('CONSOLE::MENU');
            window.location.href = (
                (process.env['REACT_APP_IAM_FRONT_HOST']
                    ? process.env['REACT_APP_IAM_FRONT_HOST']
                    : process.env['REACT_APP_BACKEND_HOST'])
                || 'http://localhost:3001') + '/' + urlContexts.iam_front;
        });
}

// const getToken = () => keycloak.token;
const refreshToken: () => void = async () => {
    const currentToken = sessionStorage.getItem('REDIRECT::INFO') ?? '';
    await getRefreshToken(currentToken)
        .then(async response => {
            if (response?.header?.errorCode === '200') {
                sessionStorage.setItem('REDIRECT::INFO', await response?.data?.accessToken);
                sessionStorage.setItem('TOKEN::EXPIREINFO', await response?.data?.expiresIn);
            }
            else doLogout();
        })
        .catch(() => {
            doLogout();
        });
};

const inactivityParams: () => Promise<{
    automatic_close_session_after: number;
    show_alert_inactivity_after: number;
}> = async () => {
    let params = {
        "show_alert_inactivity_after": 300,
        "automatic_close_session_after": 420,
    }
    await getInactivityParams(token)
        .then(async response => {
            params = response.data;
        })
        .catch(error => console.log(error));
    return params;
};

const doLogout = async (hasRedirection: boolean = true, activeToken?: string) => {
    const currentToken = activeToken ?? sessionStorage?.getItem('REDIRECT::INFO') ?? '';
    const response = await logout(currentToken);

    if (response?.header?.errorCode === '200') {
        sessionStorage.clear();
        hasRedirection ? (() => {
            window.location.href = (
                (process.env['REACT_APP_IAM_FRONT_HOST']
                    ? process.env['REACT_APP_IAM_FRONT_HOST']
                    : process.env['REACT_APP_BACKEND_HOST'])
                || 'http://localhost:3001') + '/' + urlContexts.iam_front;
        })() : sessionStorage.setItem('ONIDLE::INACTIVITY', 'true');
    }
    else window.location.reload();
};

// const doUpdateToken = () => keycloak.updateToken(-1);
const selectTenantAction: (tenantId: string, roleId?: string) => void = async (tenantId: string, roleId?: string) => {
    const currentToken = sessionStorage.getItem('REDIRECT::INFO') ?? '';
    await selectTenant(currentToken, tenantId, roleId ?? undefined)
        .then(async response => { })
        .catch(() => { });
};
const selectApplicationAction: (tenantId: string, appId: string) => void = async (tenantId: string, appId: string) => {
    const currentToken = sessionStorage.getItem('REDIRECT::INFO') ?? '';
    await selectApplication(currentToken, tenantId, appId)
        .then(async response => { })
        .catch(() => { });
};

const selectRoleAction: (
    tenantId: string,
    appId: string,
    roleId: string,
    segment: string,
    env: string,
) => void = async (tenantId: string, appId: string, roleId: string, segment: string, env: string) => {
    const currentToken = sessionStorage.getItem('REDIRECT::INFO') ?? '';
    await selectRole(currentToken, tenantId, appId, roleId, segment, env)
        .then(async response => { })
        .catch(() => { });
};
export const auth = {
    initIam,
    doLogout,
    refreshToken,
    selectTenantAction,
    selectApplicationAction,
    selectRoleAction
}